<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <div class="characteristics" *ngFor="let item of characteristics" dir="ltr">
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.Pressure"
      >
        <mat-label>{{ t('inspection.fields.pressure') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') + ':' + (inspection?.title || '') + ':pressure'
          "
          [drawableFieldTitle]="t('inspection.fields.pressure')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.pressure"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>psi</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.StaticPressure"
      >
        <mat-label>{{ t('inspection.fields.staticPressure') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':staticPressure'
          "
          [drawableFieldTitle]="t('inspection.fields.staticPressure')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.staticPressure"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>psi</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.ResidualPressure"
      >
        <mat-label>{{ t('inspection.fields.residualPressure') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':residualPressure'
          "
          [drawableFieldTitle]="t('inspection.fields.residualPressure')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.residualPressure"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>psi</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.NominalPressure"
      >
        <mat-label>{{ t('inspection.fields.nominalPressure') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':nominalPressure'
          "
          [drawableFieldTitle]="t('inspection.fields.nominalPressure')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.nominalPressure"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>psi</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.FlowRate"
      >
        <mat-label>{{ t('inspection.fields.flowRate') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') + ':' + (inspection?.title || '') + ':flowRate'
          "
          [drawableFieldTitle]="t('inspection.fields.flowRate')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.flowRate"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>gpm</span>
      </mat-form-field>

      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.DeclaredPressure"
      >
        <mat-label>{{ t('inspection.fields.declaredPressure') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':declaredPressure'
          "
          [drawableFieldTitle]="t('inspection.fields.declaredPressure')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.declaredPressure"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>psi</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.MeasuredPressure"
      >
        <mat-label>{{ t('inspection.fields.measuredPressure') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':measuredPressure'
          "
          [drawableFieldTitle]="t('inspection.fields.measuredPressure')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.measuredPressure"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>psi</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.RotationSpeed"
      >
        <mat-label>{{ t('inspection.fields.rotationSpeed') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':rotationSpeed'
          "
          [drawableFieldTitle]="t('inspection.fields.rotationSpeed')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.rotationSpeed"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>rpm</span>
      </mat-form-field>
      <mat-form-field
        class="numerical"
        floatLabel="always"
        appearance="fill"
        *ngIf="item === charType.PoolingVolume"
      >
        <mat-label>{{ t('inspection.fields.poolingVolume') }}</mat-label>
        <input
          type="number"
          min="0"
          matInput
          placeholder="0"
          [drawableField]="
            (fieldSection || '') +
            ':' +
            (inspection?.title || '') +
            ':poolingVolume'
          "
          [drawableFieldTitle]="t('inspection.fields.poolingVolume')"
          [drawableFieldReadonly]="readonly"
          [(ngModel)]="inspection.poolingVolume"
          [readonly]="readonly || printPreview"
          (input)="onChange()"
        />
        <span class="prefix" matSuffix>m^3</span>
      </mat-form-field>

      <div class="flow-pressure" *ngIf="item === charType.WaterFlowPressure">
        <mat-form-field class="psi" floatLabel="always" appearance="fill">
          <mat-label>{{ t('inspection.fields.wfpPressure') }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="
              (fieldSection || '') +
              ':' +
              (inspection?.title || '') +
              ':wfpPressure'
            "
            [drawableFieldTitle]="t('inspection.fields.wfpPressure')"
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="inspection.waterFlowPressure.pressure"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
          <span class="prefix" matSuffix>psi</span>
        </mat-form-field>
        <span class="seperator">@</span>
        <mat-form-field class="gpm" floatLabel="always" appearance="fill">
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="
              (fieldSection || '') +
              ':' +
              (inspection?.title || '') +
              ':wfpFlowRate'
            "
            [drawableFieldTitle]="t('inspection.fields.wfpFlowRate')"
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="inspection.waterFlowPressure.flowRate"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
          <span class="prefix" matSuffix>gpm</span>
        </mat-form-field>
      </div>
    </div>
  </authority-labs-check-case>
</ng-container>
